exports.routes = {
    home: `/`,
    about: `/about-us`,
    privacy: `/privacy-policy`,
    term: `/terms-and-conditions`,
    subscription: `/subscription-agreement`,
    contact: `/contact-us`,
    login: `/sign-in`,
    signup: `/sign-up`,
    findJob: `/find-job`,
    homeFindCare: `/find-care`,
    blog: `/blog`,
    blogDetail: `/blog/info/`,
    userRegister: `/user/sign-up`,
    otp: `/user/verification-otp`,
    dashboard: `/user/dashboard`,
    userDetail: `/user/info`,
    advertisementDetails: `/user/advertisement/info`,
    findCare: `/user/find-care`,
    findCareHomeAss: `/user/find-care-home-assessment`,
    message: `/user/message`,
    userMessage: `/user/message/id`,
    myJobs: `/user/jobs`,
    jobDetails: `/user/job/info`,
    moreProvider: `/provider/job/more-provider`,
    careNetwork: `/user/care-network`,
    careNetworkDetails: `/user/care-network/info`,
    jobRequest: `/user/care-network/job-request`,
    appliedJob: `/user/care-network/applied-job`,
    postedJob: `/user/care-network/posted-job`,
    addPost: `/user/care-network/job-post`,
    payment: `/user/care-network/job-post/payment`,
    paymentSuccess: `/user/care-network/job-post/payment-success`,
    paymentError: `/user/care-network/job-post/payment-error`,
    profile: `/user/profile`,
    calendar: `/user/calendar`,
    subscriptionPlan: `/user/subscription-plan`,
    newsletter: `/user/newsletter`,
    aboutUs: `/user/about-us`,
    privacyPolicy: `/user/privacy-policy`,
    termsCondition: `/user/terms-condition`,
    contactUs: `/user/contact-us`,
    transactionList: `/user/transaction-history`,

    expenseDashboard: `/user/expenses/dashboard`,
    expenseCreate: `/user/expenses/create`,
    expenseEdit: `/user/expenses/edit`,
    expenseList: `/user/expenses/listing`,
    budgetList: `/user/expenses/budget/listing`,

    communityDashboard: `/user/community/dashboard`,
    communitySuggested: `/user/suggested/community`,
    communityFollowing: `/user/community/following`,
    communityList: `/user/community/list`,
    communityInfo: `/user/community/info`,
    communityPostInfo: `/user/community/post/info`,
    communityShareProfile: `/user/community/share/profile`,
    
    careLoyalty: `/user/care-loyalty`,

    careGiverArizona: `/find-job/AZ`,
    careGiverCalifornia: `/find-job/CA`,
    careGiverFlorida: `/find-job/FL`,
    careGiverNevada: `/find-job/NV`,
    careGiverNewYork: `/find-job/NY`,
    careGiverTexas: `/find-job/TX`,
    careGiverGeorgia: `/find-job/GA`,
    careGiverMaryland: `/find-job/MD`,
    careGiverIllinois: `/find-job/IL`,
    careGiverNewJersey: `/find-job/NJ`,

    careSeekerArizona: `/find-care/AZ`,
    careSeekerCalifornia: `/find-care/CA`,
    careSeekerNevada: `/find-care/NV`,
    careSeekerFlorida: `/find-care/FL`,
    careSeekerNewYork: `/find-care/NY`,
    careSeekerTexas: `/find-care/TX`,
    careSeekerGeorgia: `/find-care/GA`,
    careSeekerMaryland: `/find-care/MD`,
    careSeekerIllinois: `/find-care/IL`,
    careSeekerNewJersey: `/find-care/NJ`,

}